import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className='footerContainer'>
        <div className="contact">
            <div className="logoName">
              <div className="logo">
                  <img width="40" height="40" src="https://img.icons8.com/stickers/40/movie-projector.png" alt="movie-projector"/>
              </div>
              <div className="name">Show box</div>
            </div>
            <div className="contact-links">
              <div className="clink">
                  <i className='fa-regular fa-envelope'></i>
                  <span className="linkName">vishalsavita809018@gmail.com</span>
              </div>
              <div className="clink">
                  <Link target={'_blank'}  
                  to="https://www.linkedin.com/in/vishal-savita-876624169/" 
                  className='clink'>
                    <i className='fa-brands fa-linkedin'></i>
                    <span className="linkName">Linked In</span>
                  </Link>
              </div>
              <div className="clink">
                  <Link target={'_blank'} to="https://github.com/Spacious74" className='clink'>
                    <i className='fa-brands fa-github'></i>
                    <span className="linkName">GitHub</span>
                  </Link>
              </div>
            </div>
        </div>
      <div className="lastLine">© Developed and Designed by - Vishal Savita</div>
    </div>
  )
}

export default Footer
